//update_insight_preferences_api_call

import { asyncHandler } from '../../../async-handler';
import store from '../../../../../store/store';
import { RequestInfo } from '../../../../../interfaces/RequestInfo';
import { TARA_INSIGHT_PREFERENCES_API } from '../../../../constants/central-api';
import { applicationJSONBodyBuilder } from '../../../../utils/body-builder';

export default async function update_insight_preferences_api_call(data: any) {
  const shop_slug = store.getState().user.company.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const requestInfo: RequestInfo = {
    url: TARA_INSIGHT_PREFERENCES_API(shop_slug),
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
    body: applicationJSONBodyBuilder(data),
  };

  const actionType = 'UPDATE_NOTIFICATIONS_PREFERENCES_API';
  const customMsg = 'Notifications preferences successfully updated.';

  const res: any = await asyncHandler(requestInfo, actionType, customMsg, true);
  const response = res?.data;

  if (res.actionType === actionType && response.success === true) {
    return response?.data;
  } else {
    return null;
  }
}
